import React, { useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/toaster";
import { LanguageProvider } from "./context/LanguageContext";
import Header from "./components/Header";
import HeroCarousel from "./components/HeroCarousel";
import About from "./components/About";
import Menu from "./components/Menu";
import Gallery from "./components/Gallery";
import Sponsor from "./components/Sponsor";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import ReservationDialog from "./components/ReservationDialog";
import CookieBanner from "./components/CookieBanner";
import { Phone } from "lucide-react";
import { restaurantInfo } from "./data/mock";

function Home() {
  const [resOpen, setResOpen] = useState(false);
  return (
    <div className="App">
      <Header onReserve={() => setResOpen(true)} />
      <HeroCarousel onReserve={() => setResOpen(true)} />
      <About />
      <Menu />
      <Sponsor />
      <Gallery />
      <Contact onReserve={() => setResOpen(true)} />
      <Footer />
      <ReservationDialog open={resOpen} onClose={() => setResOpen(false)} />

      {/* Floating call button (mobile emphasis) */}
      <a
        href={`tel:${restaurantInfo.phoneClean}`}
        className="fixed bottom-6 right-6 z-40 lg:hidden w-14 h-14 rounded-full bg-[#E86D1F] text-white flex items-center justify-center shadow-2xl glow-orange"
        aria-label="Anrufen"
      >
        <Phone size={22} />
      </a>

      <CookieBanner />
      <Toaster />
    </div>
  );
}

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
